import type { IMenuSection } from "@fondationcss/ui";

export const menus: IMenuSection[] = [
  {
    title: 'Déclarations',
    icon: 'clipboard-list',
    iconOnly: true,
    maxGroups: 10,
    groups: [
      { title: 'Tableau de bord', icon: 'dashboard', to: '/dashboard' },
      { title: 'Élèves', icon: 'user-group', to: '/eleves' },
      { title: 'Adresses', icon: 'location-dot', to: '/adresses' },
      {
        id: 'fp',
        label: 'Professionnel (FP)',
        icon: 'graduation-cap',
        iconOnly: false,
        items: [
          {
            items: [
              { title: 'Déclarations d\'effectif', icon: 'file-lines', to: '/fp/declarations' },
              { title: 'Déclarations de service', icon: 'file-contract', to: '/fp/services' },
              { title: 'Résultats', icon: 'clipboard-check', to: '/fp/resultats' },
            ],
          },
        ],
      },
      {
        id: 'fga',
        label: 'Adultes (FGA)',
        icon: 'user-graduate',
        iconOnly: false,
        items: [
          {
            items: [
              { title: 'Déclarations d\'effectif', icon: 'file-lines', to: '/fga/declarations' },
            ],
          },
        ],
      },
      {
        id: 'fgj',
        label: 'Jeunes (FGJ)',
        icon: 'child',
        iconOnly: false,
        items: [
          {
            items: [
              { title: 'Déclarations d\'effectif', icon: 'file-lines', to: '/fgj/declarations' },
              { title: 'Résultats locaux', icon: 'clipboard-check', to: '/fgj/resultats' },
              { title: 'Inscriptions épreuves', icon: 'pen-to-square', to: '/fgj/inscriptions' },
            ],
          },
        ],
      },
    ],
  },
  {
    title: 'Transmission',
    icon: 'paper-plane',
    iconOnly: true,
    groups: [
      {
        id: 'transmission',
        label: 'Transmission',
        icon: 'paper-plane',
        iconOnly: false,
        items: [
          {
            items: [
              { title: 'Préparer et transmettre', icon: 'upload', to: '/transmissions/preparer' },
              { title: 'Suivi des transmissions', icon: 'list-check', to: '/transmissions' },
            ],
          },
        ],
      },
      {
        id: 'fichiers',
        label: 'Fichiers et rétro-information',
        icon: 'file-arrow-down',
        iconOnly: false,
        items: [
          {
            items: [
              { title: 'Demander un fichier', icon: 'file-import', to: '/fichiers' },
              { title: 'Import initial', icon: 'file-arrow-up', to: '/fichiers/import-initial' },
            ],
          },
        ],
      },
      {
        id: 'rapports',
        label: 'Rapports',
        icon: 'chart-bar',
        iconOnly: false,
        items: [
          {
            items: [
              { title: 'Sommaire des déclarations', icon: 'table-list', to: '/rapports/sommaire' },
              { title: 'Heures déclarées vs sanctionnées', icon: 'clock', to: '/rapports/heures' },
              { title: 'Taux de rejet', icon: 'triangle-exclamation', to: '/rapports/rejets' },
              { title: 'Couverture des résultats', icon: 'chart-pie', to: '/rapports/couverture' },
              { title: 'Audit trail', icon: 'magnifying-glass', to: '/rapports/audit' },
            ],
          },
        ],
      },
    ],
  },
  {
    title: 'Gestion',
    icon: 'gear',
    iconOnly: true,
    groups: [
      {
        id: 'configuration',
        label: 'Configuration',
        icon: 'gear',
        iconOnly: false,
        items: [
          {
            items: [
              { title: 'Organisme', icon: 'building', to: '/configuration/organisme' },
              { title: 'Connexion SFTP', icon: 'server', to: '/configuration/sftp' },
              { title: 'Chiffrement PGP', icon: 'lock', to: '/configuration/pgp' },
              { title: 'Utilisateurs et rôles', icon: 'users-gear', to: '/configuration/utilisateurs' },
              { title: 'Notifications', icon: 'bell', to: '/configuration/notifications' },
            ],
          },
        ],
      },
    ],
  },
]